import * as React from 'react';

import classnames from 'classnames';

import {colors} from 'shells/colors/colors';
import {ErrorState} from 'shells/error-state/error-state';
import {MiniMap} from 'shells/mini-map/mini-map';
import {ReadOnlyText} from 'shells/sms-campaigns/read-only-text';
import {UppercaseLabel} from 'shells/typography/uppercase-label';

import type {SmsDripEditionFragment as DripEdition, TimespanInput} from 'nutshell-graphql-types';

import styles from './drip-sequence-mini-map-sidebar.module.css';

type Props = {
    selectedEditionId: string;
    editions: DripEdition[];
    error: string | null | undefined;
    isLoading: boolean;
    onEditionChange: (newEditionId: string) => void;
    onUpdateEdition: (arg1: {editionId: string; delay: TimespanInput}) => Promise<any>;
    onCreateEdition: () => void;
    canAddNewEdition: boolean;
};

export function DripSequenceMiniMapSidebar(props: Props) {
    return (
        <div
            className={classnames(
                styles['drip-sequence-mini-map-sidebar'],
                styles['border-top-left-8']
            )}
        >
            <UppercaseLabel>Messages</UppercaseLabel>
            {props.error ? (
                <ErrorState errorMessage={props.error} size='small' />
            ) : (
                <div className={styles['mini-map-container']}>
                    {props.editions && (
                        <MiniMap
                            editions={props.editions.map((edition) => {
                                return {
                                    id: edition.id,
                                    name: edition.name,
                                    content: edition.content,
                                    delay: edition.delay,
                                    status: edition.status,
                                    backgroundColor: colors.white,
                                    previewComponent: (
                                        <div className={styles.preview}>
                                            <ReadOnlyText
                                                size='small'
                                                message={edition.content}
                                                optOutText={edition.optOutText || undefined}
                                                isFullWidth={true}
                                                hasLineLimit={true}
                                            />
                                        </div>
                                    ),
                                };
                            })}
                            selectedId={props.selectedEditionId}
                            onSelectMessage={(editionId) => {
                                setTimeout(() => {
                                    props.onEditionChange(editionId);
                                }, 1);
                            }}
                            onAddMessage={
                                props.canAddNewEdition ? props.onCreateEdition : undefined
                            }
                            isLoading={props.isLoading}
                            onUpdateEdition={props.onUpdateEdition}
                        />
                    )}
                </div>
            )}
        </div>
    );
}
